import dayjs from "../dayjs";
import { DATE_STRING } from "../model/busRoute";

export const formatToDateString = (date) => {
    if(!date) {
        return null;
    }
    if(typeof date === 'string') {
        return dayjs(date).format(DATE_STRING);
    }
    return date.format(DATE_STRING);
}
